import { useEffect, useState } from "react";
import { IMarketplace } from "../../../interfaces/IMarketplace";
import { useSnackbar } from "../../../../core/contexts/SnackbarContext";
import { useMarketplaces } from "../../../hooks/useMarketplaces";
import { useIFood } from "../../../hooks/useIFood";
import { IIntegracaoIFood } from "../../../interfaces/IIntegracaoMarketplace";
import { PageContainer } from "./styles";
import { PrimeiraEtapaVinculoIFood } from "./components/PrimeiraEtapaVinculoIFood";
import { SegundaEtapaVinculoIFood } from "./components/SegundaEtapaVinculoIFood";

interface VincularMarketplaceProps {
    marketplace: IMarketplace
    handleRefresh: () => void,
    loadingFetch: boolean
}
export const VincularMerchantIFoodV2 = ({
    handleRefresh,
    loadingFetch,
    marketplace
}: VincularMarketplaceProps) => {
    const [etapa, setEtapa] = useState<number>(1);
    const [authorizationCode, setAuthorizationCode] = useState<string>("");

    const [dadosVinculo, setDadosVinculo] = useState<{
        accessToken: string | undefined;
        merchantId: string | undefined;
        catalogId: string | undefined;
        refreshToken: string | undefined;
        authorizationCodeVerifier: string | undefined;
    }>({
        accessToken: undefined,
        merchantId: undefined,
        catalogId: undefined,
        refreshToken: undefined,
        authorizationCodeVerifier: undefined
    });
    const [estabelecimentos, setEstabelecimentos] = useState<{
        id: string;
        nome: string;
    }[]>([]);
    const [catalogos, setCatalogos] = useState<{
        id: string;
        contexto: string;
    }[]>([]);
    const [authorizationCodeVerifier, setAuthorizationCodeVerifier] = useState<string>("");

    const snackbar = useSnackbar();
    const {
        salvar
    } = useMarketplaces();

    const {
        listarCatalogos,
        loading
    } = useIFood();

    const integracao = marketplace?.configuracao?.integracao as IIntegracaoIFood;

    const listarCatalogosMarketplace = async () => {
        const catalogosMarketplace = await listarCatalogos(marketplace.uuid as string);
        if (catalogosMarketplace) {
            setCatalogos(catalogosMarketplace);
        }
    };

    const excluir = async () => {
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                integracao: undefined
            }
        });
        window.location.reload();
    }

    const handleVincularEstabelecimento = async (merchantId: string) => {
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                integracao: {
                    merchantId
                }
            }
        });
        setDadosVinculo({
            ...dadosVinculo,
            merchantId
        });
        await listarCatalogosMarketplace();
        setEtapa(2);
    }

    const voltar1etapa = async () => {
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                integracao: {
                    merchantId: undefined
                }
            }
        });
        window.location.reload();
    }

    const handleVincularCatalogo = async (catalogId?: string) => {
        const catalogo = catalogos?.find(catologo => catologo.id == catalogId);
        if(!catalogo) {
            return snackbar("Catálogo não encontrado", { severity: "error" });
        }
        salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                integracao: {
                    accessToken: dadosVinculo?.accessToken,
                    merchantId: dadosVinculo?.merchantId,
                    refreshToken: dadosVinculo?.refreshToken,
                    catalogId
                }
            }
        });
        setDadosVinculo({
            ...dadosVinculo,
            catalogId
        })
        window.location.reload();
    };

    useEffect(() => {
        if (marketplace) {
            setDadosVinculo({
                accessToken: integracao?.accessToken,
                merchantId: integracao?.merchantId,
                refreshToken: integracao?.refreshToken,
                catalogId: integracao?.catalogId,
                authorizationCodeVerifier: authorizationCodeVerifier ?? undefined
            });
        }
    }, [marketplace])

    useEffect(() => {
        if (dadosVinculo?.merchantId) {
            setEtapa(2);
            listarCatalogosMarketplace();
            return;
        }
    }, [dadosVinculo]);

    return (
        <PageContainer>
            {etapa == 1 && <PrimeiraEtapaVinculoIFood
                estabelecimentoConfigurado={dadosVinculo?.merchantId}
                marketplaceUuid={marketplace?.uuid}
                loading={loading}
                vincular={handleVincularEstabelecimento}
            />
            }
            {etapa == 2 && <SegundaEtapaVinculoIFood
                loading={loading}
                catalogos={catalogos}
                catalogoSelecionado={dadosVinculo?.catalogId}
                vincular={handleVincularCatalogo}
                voltar={voltar1etapa}
            />}
        </PageContainer>
    );
}